<template>
  <main-layout>
    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-105"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">
          <img slot="back" class="back-image" src="@/assets/icon/sp-icon-arrow-back.svg" @click="back"/>
          <label class="m-left-5" slot="title"> {{$t('label.router.reserveOptionConfirm')}}</label>
        </label>

        <narrow-down slot="create" @click="saveOption">
          {{ $t('label.system.option.save') }}
        </narrow-down>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">
      <div class="page-title-style">
        {{ $t('label.router.reserveOptionConfirm') }}
      </div>

      <div class="content-title-style">
        {{ query.title }}
      </div>

      <div class="content-div-type">
        <survey-area
          :questionList="questionList"
          :title="query.title"
          :enqueteRemark="query.enqueteRemark"
          :chooseNumberFlag="'03'"
        />
      </div>

      <div>
        <narrow-down  @click="saveOption">
          {{$t('label.system.option.save') }}
        </narrow-down>
      </div>

      <loading-dialog :dialogVisible="showLoading" />

      <dialog-confirm
        :clickFlag="false"
        :visible.sync="isDialogConfirmComplete"
        :titleMsg="dialogComplete.title"
        :contentMsg="dialogComplete.content"
        :cancelFlag="cancelFlag"
        @on-confirm="optionConfirm"/>

    </div>

  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import headTitle from "@/components/common/head/head"
import Menubar from "@/components/leftmenu/DashBoard"
import SurveyArea from "@/components/common/survey/QuestionSurvey";
import DialogConfirm from "@/components/common/el-dialog-prompt/confirm";
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg";
import statusErrorCodeMsg from "@/utils/status-error-msg"


export default {
  name: "BuildingSearch",
  components: {
    MainLayout: NewDesignLayout,
    headTitle: headTitle,
    narrowDown: narrowDown,
    Menubar: Menubar,
    SurveyArea:SurveyArea,
    DialogConfirm:DialogConfirm,
    LoadingDialog:LoadingDialog
  },
  data() {

    return {
      buildingId:null,
      query:null,
      questionList:[],
      optionList:[],
      showLoading:false,
      flag:true,
      isDialogConfirmComplete: false,
      cancelFlag: true,
      dialogComplete: {
        title:'登録確認',
        content:null,
      },
      moveFlag:null,
      intention: null,
    }
  },
  methods: {
    optionConfirm(){
      if(this.flag){
        this.flag = false
        if(this.intention == 'confirm'){
          this.showLoading = true
          let optionDetailList = [];
          for (let question of this.optionList) {
            let choiceList = [];
            if(question.questionInputMode != "01"){
              for (let answer of question.questionAnswerList) {
                choiceList.push({
                  choiceContent:answer.content,
                  otherFlag: answer.otherExistsFlag,
                  choiceId: answer.choiceId,
                })
              }
            }

            let detailId = "";
            if(question.detailId != null && question.detailId != undefined){
              detailId = question.detailId
            }

            if(!this.$IsNullOrEmpty(question.maxLength)){
              optionDetailList.push({
                content: question.questionContent,
                commonFlag:question.commonFlag,
                inputMode: question.questionInputMode,
                mustFlag: question.mustFlag,
                maxLength: question.maxLength,
                choiceList : choiceList,
                detailId: detailId,
              })
            }else{
              optionDetailList.push({
                content: question.questionContent,
                commonFlag:question.commonFlag,
                inputMode: question.questionInputMode,
                mustFlag: question.mustFlag,
                choiceList : choiceList,
                detailId: detailId,
              })
            }
          }
          let query = {
            optionTitle : this.query.title,
            optionRemark : this.query.enqueteRemark ? this.query.enqueteRemark : null,
            commonShowFlag : this.query.commonQuestionFlag,
            commonFlag : this.query.commonFlag,
            optionDetailList : optionDetailList
          }
          if(this.moveFlag == '01'){
            query.buildingId = this.buildingId,
            SystemManageApi.createBuildReservationOption(query)
            .catch((error) => {
              errorCodeMsg(error, this)
              this.showLoading = false
            })
            .then(({data}) => {
              if (!statusErrorCodeMsg(data.statusCode, this)) {
                this.showLoading = false
                return;
              }
              this.$nextTick(() => {
                this.showLoading = false
                this.intention = "back"
                this.dialogComplete.content = this.$t("label.system.option.optionConfirmDone"),
                this.cancelFlag = false
                this.isDialogConfirmComplete = true
              });
            }).finally(()=>{
              this.flag = true
            })

          }else if(this.moveFlag == '02'){
            SystemManageApi.updateBuildReservationOption(this.query.optionId,query)
            .catch((error) => {
              errorCodeMsg(error, this)
              this.showLoading = false
            })
            .then(({data}) => {
              if (!statusErrorCodeMsg(data.statusCode, this)) {
                this.showLoading = false
                return;
              }
              this.showLoading = false
              this.intention = "back"
              this.dialogComplete.content = this.$t("label.system.option.optionConfirmDone"),
              this.cancelFlag = false
              this.isDialogConfirmComplete = true
            }).finally(()=>{
              this.flag = true
            })
          }
        }else if(this.intention == 'back'){

          this.flag = true
          this.$router.push({
            name: "reserveOptipnList",
            params: {
              buildingId: this.buildingId
            }
          })
        }
      }
    },
    back(){
      this.$savePageInfo("option", "confirmEidt", "M-06-105", "query",this.query)
      if(this.moveFlag == '01') {
        this.$router.push({
          name: "reserveOptipnCreate",
          query: {
            moveFlag : '01',
          }
        });
      }else if(this.moveFlag == '02') {
        this.$router.push({
          name: "reserveOptipnEdit",
          query: {
            moveFlag : '02',
          }
        });
      }
    },
    saveOption(){
      this.intention = "confirm"
      this.dialogComplete.content = this.$t("label.system.option.optionConfirmText"),
      this.cancelFlag = true
      this.isDialogConfirmComplete = true
    }
  },
  mounted() {
  },
  created() {
    this.buildingId = this.$route.params.buildingId
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: `/system/buildings/${this.buildingId}/detail`,
        title: "label.router.building",
      },
      {
        path: "",
        title: "label.router.reserveOptionSite",
      },
      {
        path: "",
        title: "label.router.reserveOptionCreate",
      }
    ]
    this.moveFlag = this.$route.query.moveFlag
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
    if(this.moveFlag == '01'){
      this.query = this.$getPageInfo("option", "create", "M-06-104", "query")
    }else if(this.moveFlag == '02'){
      this.query = this.$getPageInfo("option", "edit", "M-06-104", "query")
    }

    if(this.query.commonQuestionFlag){
      let hasCommonFlag = this.query.questionList.some(item => item.commonFlag == true);
      if(!hasCommonFlag){
        let commonquestion = null
        commonquestion = {
          detailId : this.query.commonQuestion.detailId,
          commonFlag : this.query.commonQuestion.commonFlag,
          mustFlag : this.query.commonQuestion.mustFlag,
          questionAnswerList : this.query.commonQuestion.questionAnswerList,
          questionContent : this.query.commonQuestion.questionContent,
          maxLength : 0,
          questionInputMode : this.query.commonQuestion.questionInputMode
        }
        this.questionList.push(commonquestion)
      }
    }
    for(let question of this.query.questionList){
      this.optionList.push(question)
      this.questionList.push(question)
    }
  }
}
</script>

<style lang="scss" scoped>
.content-div-type {
  background-color: #F7F7F2;
  border-radius: 6px;
  padding: 37px 40px 30px 40px;
  width: 100%;
  height: auto;
  color: #525250;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-bottom: 48px;
}
.page-title-style{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 20px;
  font-weight: 300;
  text-align: left;
  color: #525250;
  margin-bottom: 48px;
}
.content-title-style{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 20px;
  font-weight: 300;
  text-align: left;
  color: #525250;
  margin-bottom: 20px;
}
::v-deep .my-button{
  height: 40px;
  width: 206px;
}
</style>
